import { useBackerSpecialization } from "../hooks/use-intelligence-queries.ts";

export function BackerSpecializationMatrix() {
  const { data, isLoading, error } = useBackerSpecialization(30);

  if (isLoading) return <div className="intel-loading">Loading backer specialization…</div>;
  if (error || !data)
    return <div className="intel-error">Failed to load backer specialization</div>;

  return (
    <section className="intel-section">
      <header className="intel-section__header">
        <h3 className="intel-section__title">Backer specialization</h3>
        <p className="intel-section__subtitle">
          Inverse of the league table — for each fund, which category families they concentrate in.
          Shows the top 3 families by project count per fund. Useful for editorial framing like "top
          3 funds in DeFi lending" or "Solana-first backers."
        </p>
      </header>

      <div className="intel-spec-wrap">
        <table className="intel-spec">
          <thead>
            <tr>
              <th>Fund</th>
              <th className="intel-spec__num-head">Positions</th>
              <th className="intel-spec__families-head">Top 3 families (count · %)</th>
            </tr>
          </thead>
          <tbody>
            {data.map((row) => (
              <tr key={row.fundName}>
                <td className="intel-spec__fund">{row.fundName}</td>
                <td className="intel-spec__num">{row.totalPositions}</td>
                <td className="intel-spec__families">
                  {row.topFamilies.map((f) => (
                    <span className="intel-spec__badge" key={f.family ?? "__other__"}>
                      <span className="intel-spec__badge-family">{f.family ?? "Other"}</span>
                      <span className="intel-spec__badge-count">{f.count}</span>
                      <span className="intel-spec__badge-pct">{f.pct.toFixed(0)}%</span>
                    </span>
                  ))}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
}
